import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-12 bg-navy text-white relative overflow-hidden" data-id="element-147">
      <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/3 w-96 h-96 bg-gold/10 rounded-full blur-3xl" data-id="element-148"></div>
      <div className="absolute bottom-0 left-0 translate-y-1/2 -translate-x-1/3 w-96 h-96 bg-green-500/10 rounded-full blur-3xl" data-id="element-149"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-150">
        <FadeIn data-id="element-151">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-navy-800 border-4 border-gold mb-5 shadow-[0_0_30px_rgba(201,168,76,0.3)]" data-id="element-152">
            <ShieldCheckIcon className="w-10 h-10 text-gold" data-id="element-153" />
          </div>

          <h2 className="text-2xl md:text-3xl font-bold font-heading mb-4" data-id="element-154">
            Garantía de <span className="text-gold" data-id="element-155">120 Días</span>: "ÁMALO O
            DÉJALO" — 100% Satisfacción
          </h2>

          <p className="text-lg text-gray-300 leading-relaxed max-w-3xl mx-auto" data-id="element-156">
            Si este no es el{' '}
            <span className="underline decoration-gold decoration-2 underline-offset-2" data-id="element-157">
              recurso visual bíblico más completo
            </span>{' '}
            que hayas visto jamás, simplemente envíame un correo electrónico y
            te devolveré el
            <strong data-id="element-158"> 100% de tu dinero</strong>. <strong data-id="element-159">Sin preguntas</strong>.
          </p>
        </FadeIn>
      </div>
    </section>;
}